export const listDocumentTypes = [
    {
        text: 'Cartão CNPJ',
        value: 1
    },
    {
        text: 'Contrato Social',
        value: 2
    },
    {
        text: 'Ata Societária',
        value: 3
    },
    {
        text: 'Documento dos Sócios',
        value: 4
    },
    {
        text: 'Comprovante de Endereço',
        value: 5
    },
    {
        text: 'Outros',
        value: 6
    }
]
